import * as Yup from 'yup'
import { FormItemProps } from '@/components/Form/types'
//import GlbComponent from '@/components/UiElements/GlbComponent'
//import React from 'react'
//import Text from '@/components/Form/elements/items/Text'


const Items: Array<FormItemProps> = [
	{
		name: 'tier',
		label: 'Tier (Item #)',
		type: 'Number',
		placeholder: 'Enter tier',
		validation: Yup.number().typeError('Required'),
		disabled: true,
		classNames: {
			container: 'col-span-2 !select-none',
			content: ' !select-none hover:!border-gray-300 !bg-gray-50',
			validation: 'hidden'
		}
	},
	{
		name: 'price_rule',
		label: 'Rule Type',
		type: 'Select',
		placeholder: 'Select rule type',
		itemOptions: {
			list: [
				{ value: 'FIXED_AMOUNT', label: 'Fixed Amount ($)' },
				{ value: 'PERCENTAGE_DISCOUNT', label: 'Percentage Discount (%)' },
				{ value: 'AMOUNT_DISCOUNT', label: 'Amount Discount ($)' },
				/*{ value: 'PERCENTAGE_OF_BASE', label: 'Percentage of Base Price (%)' },*/
			],
		},
		classNames: {
			container: 'col-span-4',
			validation: 'hidden'
		}
	},
	{
		name: 'value',
		label: 'Value',
		type: 'Number',
		placeholder: 'Enter value',
		validation: Yup.number().typeError('Required'),
		classNames: {
			container: 'col-span-5',
			validation: 'hidden'
		}
	},
	{
		name: 'delete',
		label: 'Delete',
		type: 'Button',
		placeholder: '',
		itemOptions: {
			buttonType: 'danger',
		},
		classNames: {
			container: 'col-span-1 font-icon-solid ',
			label: 'opacity-0',
			validation: 'hidden'
		},
		condition: (data: any, formData: any) => {
			console.log(data, formData)
			return true
			//return formData?.rulesList?.length > 1
		}
	},

]

export default Items;